var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"textarea"},[_c('textarea',{ref:"text",on:{"input":function($event){return _vm.$emit('update:response', _vm.$refs.text.value)}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }